import { TableRow } from "../ProcessTableUtils";
import DownloadAsCsvDropdown from "./DownloadAsCsvDropdown";
import PageTitle from "./PageTitle";
import { ProcessTableColumnSelector } from "./ProcessTableColumnSelector";
import { ProcessTableFavoriteViewToggle } from "./ProcessTableFavoriteViewToggle";
import { ProcessTableFilterSelector } from "./ProcessTableFilterSelector";
import { ProcessTableGroupingSelector } from "./ProcessTableGroupingSelector";
import { ProcessTableSortView } from "./ProcessTableSortView";
import ProcessTableViewsSection from "./ProcessTableViewsSection";
import { QuickFiltersToggle } from "./QuickFiltersToggle";
import { ArchivedFilter, SQLGeneratedProcess } from "@avenueops/shared-types";
import { ProcessView } from "@prisma/client";
import { Table } from "@tanstack/react-table";
import SearchBar from "components/generic-building-blocks/SearchBar";
import { useProcessTableFilters, useProcessTableSearch, useProcessTableState } from "context/ProcessTableContext";
import React from "react";

interface Props {
  signalView?: ProcessView;
  isDashboard: boolean;
  showQuickFilters: boolean;
  setShowQuickFilters: (_: boolean) => void;
  table: Table<TableRow>;
  archived: ArchivedFilter;
  setSelectedProcess: (_: SQLGeneratedProcess | null) => void;
}

export function ProcessTableHeader({
  signalView,
  isDashboard,
  showQuickFilters,
  setShowQuickFilters,
  table,
  archived,
  setSelectedProcess,
}: Props): JSX.Element {
  const [filters, setFilters] = useProcessTableFilters();
  const [search, setSearch] = useProcessTableSearch();
  const [processTableState, _] = useProcessTableState();

  return (
    <div className="flex flex-row w-full h-full items-center px-2">
      <div className="flex flex-row flex-1 items-center">
        <PageTitle archived={archived} signalView={signalView} isDashboard={isDashboard} />
        {signalView && <ProcessTableFavoriteViewToggle signalView={signalView} />}
      </div>

      <div className="flex flex-row gap-1 items-center">
        <ProcessTableSortView />
        <ProcessTableFilterSelector filters={filters ?? []} setFilters={setFilters} isDashboard={isDashboard} />
        <ProcessTableGroupingSelector />
        <ProcessTableViewsSection signalView={signalView} />
        <ProcessTableColumnSelector table={table} />
        <DownloadAsCsvDropdown archived={archived} processTableState={processTableState} isDashboard={isDashboard} />
        <div>
          <SearchBar search={search} setSearch={setSearch} size="MEDIUM" />
        </div>
        <QuickFiltersToggle showQuickFilters={showQuickFilters} setShowQuickFilters={setShowQuickFilters} setSelectedProcess={setSelectedProcess} />
      </div>
    </div>
  );
}
